import { createAction } from '@poa/state';

// fetching
export const fetchStats = createAction('fetchFinances', () => ({}));
export const fetchSuccess = createAction('fetchFinancesSuccess', data => ({ data }));
export const fetchFailed = createAction('fetchFinancesFailed', () => ({}));
export const fetchStatsWaiting = createAction('fetchStatsWaiting', data => ({ data }));
export const fetchEmptyStats = createAction('fetchEmptyStats', () => ({}));

// presets
export const changeColumnPreset = createAction('changeFinancesColumnPreset', presetId => ({
  presetId
}));
export const changeColumnVisibility = createAction('changeFinancesColumnVisibility', column => ({
  column
}));
export const toggleAllColumns = createAction('toggleAllColumnsFinances', () => ({}));
export const saveColumnPreset = createAction(
  'saveColumnPresetFinances',
  (preset, availablePresets) => ({
    preset,
    availablePresets
  })
);
export const deletePreset = createAction('deletePresetFinances', id => ({ id }));
export const resetColumnSettings = createAction(
  'resetColumnSettings',
  ({ availablePresets, presetId }) => ({
    availablePresets,
    presetId
  })
);
export const changePresetOrder = createAction('financesChangePresetOrder', columns => ({
  columns
}));

export const changeSearch = createAction('changeSearchFinances', searchClause => ({
  searchClause
}));

export const setDates = createAction('setDates', ({ startDate, endDate, shouldFetch = true }) => ({
  startDate,
  endDate,
  shouldFetch
}));
